import { Entity, EntityType, fetchEntityChunk } from '@neptune/shared/entity-domain';
import { makeEntityIdentifier } from '@neptune/shared/entity-util';

import { knownAttributes } from 'domain/experiment/attribute';
import { AsyncActionsReturnType, createAsyncActions } from 'state/async-actions';

export enum CurrentBasicEntityActionTypes {
  request = 'CURRENT_BASIC_ENTITY_FETCH',
  success = 'CURRENT_BASIC_ENTITY_FETCH_SUCCESS',
  fail = 'CURRENT_BASIC_ENTITY_FETCH_FAIL',
}

export enum UpdateCurrentBasicEntityActionTypes {
  request = 'UPDATE_CURRENT_BASIC_ENTITY_FETCH',
  success = 'UPDATE_CURRENT_BASIC_ENTITY_FETCH_SUCCESS',
  fail = 'UPDATE_CURRENT_BASIC_ENTITY_FETCH_FAIL',
}

type EntityAddress = {
  organizationName: string;
  projectName: string;
  runIdentificationKey: string;
};

const basicEntityActions = createAsyncActions({
  types: CurrentBasicEntityActionTypes,
  resolver: ({
    organizationName,
    projectName,
    runIdentificationKey,
  }: EntityAddress): Promise<Entity> => {
    const id = makeEntityIdentifier(organizationName, projectName, runIdentificationKey);
    return fetchEntityChunk({ id, fieldsToFetch: knownAttributes, holderType: 'experiment' });
  },
});

const updateBasicEntityActions = createAsyncActions({
  types: UpdateCurrentBasicEntityActionTypes,
  resolver: ({ id, type }: { id: string; type: EntityType }): Promise<Entity> => {
    return fetchEntityChunk({ id, fieldsToFetch: knownAttributes, type });
  },
});

export const { execute: fetchBasicCurrentEntity } = basicEntityActions;
export const { execute: updateBasicCurrentEntity } = updateBasicEntityActions;

export type CurrentEntityActions =
  | AsyncActionsReturnType<typeof basicEntityActions>
  | AsyncActionsReturnType<typeof updateBasicEntityActions>;
